export function validarNumeroTelefone(numero: string) {
   const regex = /^(?:(?:\+|00)?55\s?)?(?:\(?([1-9][0-9])\)?\s?)?(9?\d{4})-?(\d{4})$/;
   return regex.test(numero);
}